export default [
  // {
  //   path: '/AdminLogin',
  //   name: 'Login',
  //   meta: { title: '' },
  //   component: () => import('@/components/functions/Auth/PgLogin')
  // },
  // {
  //   path: '/Top',
  //   name: 'Top',
  //   meta: { title: '' },
  //   component: () => import('@/components/functions/Top/TopIndex')
  // },
  // {
  //   path: '/D0101Demo',
  //   name: 'D0101Demo',
  //   meta: { title: '' },
  //   component: () => import('@/components/functions/D0101Demo/D0101DemoIndex')
  // },
  // {
  //   path: '/M0001User',
  //   name: 'M0001User',
  //   meta: { title: '' },
  //   component: () => import('@/components/functions/M0001User/M0001UserIndex')
  // },
  // {
  //   path: '/About',
  //   name: 'About',
  //   meta: { title: 'About - Melange' },
  //   component: () => import('@/components/functions/About/AboutIndex')
  // },
  // {
  //   path: '/Client',
  //   name: 'Client',
  //   meta: { title: 'Clients - Melange' },
  //   component: () => import('@/components/functions/Client/ClientIndex')
  // },
  // {
  //   path: '/Service',
  //   name: 'Service',
  //   meta: { title: 'Service - Melange' },
  //   component: () => import('@/components/functions/Service/ServiceIndex')
  // },
  // {
  //   path: '/Gallery',
  //   name: 'Gallery',
  //   meta: { title: 'Gallery - Melange' },
  //   component: () => import('@/components/functions/Gallery/GalleryIndex')
  // },
  // {
  //   path: '/GalleryDetail/:id/:name',
  //   name: 'GalleryDetail',
  //   meta: { title: 'Gallery Detail - Melange' },
  //   component: () => import('@/components/functions/Gallery/GalleryDetail')
  // },
  // {
  //   path: '/Contact',
  //   name: 'Contact',
  //   meta: { title: 'Contact - Melange' },
  //   component: () => import('@/components/functions/Contact/ContactIndex')
  // },
  // {
  //   path: '/Privacy',
  //   name: 'Privacy',
  //   meta: { title: 'Privacy - Melange' },
  //   component: () => import('@/components/functions/Information/Privacy')
  // },
  // {
  //   path: '/T&C',
  //   name: 'T&C',
  //   meta: { title: 'Terms & Conditions - Melange' },
  //   component: () => import('@/components/functions/Information/T&C')
  // },
  // {
  //   path: '/ShippingTerms',
  //   name: 'ShippingTerms',
  //   meta: { title: 'Shipping Terms - Melange' },
  //   component: () => import('@/components/functions/Information/ShippingTerms')
  // },
  // {
  //   path: '/ProductList',
  //   name: 'ProductList',
  //   meta: { title: 'Shop - Melange' },
  //   component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopIndex')
  // },
  // {
  //   path: '/Product/:id/:name',
  //   name: 'Product',
  //   meta: { title: 'Product Detail - Melange' },
  //   component: () => import('@/components/functions/M0006OnlineShop/M0006OnlineShopProductDetail')
  // },
  // {
  //   path: '/ShoppingCart',
  //   name: 'ShoppingCart',
  //   meta: { title: 'Shopping Bag - Melange' },
  //   component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  // },
  // {
  //   path: '/CheckOut',
  //   name: 'CheckOut',
  //   meta: { title: 'Check Out - Melange' },
  //   component: () => import('@/components/functions/M0009CheckOut/CheckOutIndex')
  // },
  // {
  //   path: '/ShoppingCart/:status',
  //   name: 'Payment',
  //   meta: { title: 'Shopping Bag - Melange' },
  //   component: () => import('@/components/functions/M0008ShoppingCart/CartIndex')
  // },
  // {
  //   path: '/PurchaseDetail/Received/:p0201_id/:purchase_num/:temp_token',
  //   name: 'PurchaseDetail',
  //   meta: { title: 'Purchase Detail - Melange' },
  //   component: () => import('@/components/functions/M0009CheckOut/PurchaseReceived')
  // },
  // {
  //   path: '/Survey/:id',
  //   name: 'Survey',
  //   meta: { title: 'Survey - Melange' },
  //   component: () => import('@/components/functions/M0601Survey/M0601SurveyIndex')
  // },
  {
    path: '/',
    name: 'HomePage',
    meta: { title: 'Melange Art Consultancy' },
    component: () => import('@/components/functions/M0006OnlineShop/M0006Home')
  },
  {
    path: '*',
    redirect: '/'
  }
]
